import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { useCurrentOrg } from '@/features/org/hooks/use-org';
import { getOrgProjects } from '@/features/projects/shared/api/get-org-projects';
import { useProjectHubFilterStore } from '@/shared/hooks/use-hub-filter-store';
import { ProjectWithContractors } from '@/shared/types/api';

export const getProjectsQueryKey = (orgId?: number) => ['projects', orgId];

type Props = Omit<
  UseQueryOptions<ProjectWithContractors[], unknown, ProjectWithContractors[]>,
  'queryKey' | 'queryFn'
>;

export const useProjects = (props?: Props) => {
  const { data: org, isLoading: isOrgLoading } = useCurrentOrg();
  const {
    statuses,
    partnerIds,
    roles,
    notificationStatuses,
    lastEntry,
    searchQuery,
    fromDate,
    toDate,
  } = useProjectHubFilterStore();

  const filters = {
    statuses,
    partnerIds,
    roles,
    notificationStatuses,
    lastEntry,
    searchQuery,
    fromDate,
    toDate,
  };

  return useQuery({
    ...props,
    queryKey: [...getProjectsQueryKey(org?.id), filters],
    queryFn: async () => {
      if (isOrgLoading || !org) {
        return [];
      }

      const projects = await getOrgProjects({
        orgId: org.id,
        filters: {
          ...filters,
          dateFrom: fromDate,
          dateTo: toDate,
        },
      });
      return projects;
    },
    enabled: !isOrgLoading && !!org,
  });
};
